export const PA_COLUMNS = [
  { key: "patientName", label: "Patient", sortable: true, width: "180px", sticky: true, pinned: true },
  { key: "identifiers", label: "Identifiers", sortable: false, width: "200px" },
  { key: "status", label: "Status", sortable: true, width: "190px" },
  { key: "tags", label: "Tags", sortable: false, width: "180px" },
  { key: "medication", label: "Medication", sortable: true, width: "250px" },
  { key: "insurance", label: "Insurance", sortable: true, width: "150px" },
  { key: "provider", label: "Provider", sortable: false, width: "150px" },
  { key: "priorAuthNumber", label: "PA Number", sortable: false, width: "130px", mono: true },
  { key: "dateCreated", label: "Created", sortable: true, width: "140px", mono: true, datetime: true },
  { key: "modifiedBy", label: "Modified By", sortable: true, width: "130px" },
  { key: "actions", label: "", sortable: false, width: "48px", fixed: true },
];

export const INTAKE_COLUMNS = [
  { key: "patientName", label: "Patient Name", sortable: true, width: "180px", sticky: true, pinned: true },
  { key: "mrn", label: "MRN", sortable: true, width: "100px", mono: true },
  { key: "status", label: "Status", sortable: true, width: "220px" },
  { key: "tags", label: "Tags", sortable: false, width: "180px" },
  { key: "dateReceived", label: "Date Received", sortable: true, width: "130px", mono: true, datetime: true },
  { key: "insurance", label: "Insurance", sortable: true, width: "150px" },
  { key: "medication", label: "Medication", sortable: true, width: "250px" },
  { key: "documentTypes", label: "Doc Type", sortable: true, width: "140px" },
  { key: "provider", label: "Provider", sortable: true, width: "150px" },
  { key: "sentBy", label: "Sent By", sortable: true, width: "130px" },
  { key: "modifiedBy", label: "Modified By", sortable: true, width: "130px" },
  { key: "actions", label: "", sortable: false, width: "48px", fixed: true },
];
